// @flow
import { MediaSurveysActionTypes } from './constants';

type MediaSurveysAction = { type: string, payload: {} | string };

// common success
export const mediaSurveysApiResponseSuccess = (actionType: string, data: any): MediaSurveysAction => ({
    type: MediaSurveysActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const mediaSurveysApiResponseError = (actionType: string, error: string): MediaSurveysAction => ({
    type: MediaSurveysActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getMediaSurvey = (id: string): MediaSurveysAction => ({
    type: MediaSurveysActionTypes.GET_MEDIA_SURVEY,
    payload: { id },
});

export const addMediaSurvey = (mediaSurvey:any):MediaSurveysAction=>({
    type:MediaSurveysActionTypes.ADD_MEDIA_SURVEY,
    payload:mediaSurvey
})
export const updateMediaSurvey = (mediaSurvey:any):MediaSurveysAction=>({
    type:MediaSurveysActionTypes.UPDATE_MEDIA_SURVEY,
    payload:mediaSurvey
})
export const deleteMediaSurvey = (id:string):MediaSurveysAction=>({
    type:MediaSurveysActionTypes.DELETE_MEDIA_SURVEY,
    payload:{id}
})

export const listMediaSurveys = (params:any): MediaSurveysAction => ({
    type: MediaSurveysActionTypes.LIST_MEDIA_SURVEYS,
    payload: params,
});


export const resetMediaSurveys = (): MediaSurveysAction => ({
    type: MediaSurveysActionTypes.RESET,
    payload: {},
});

